import { UserWorkspaceRole } from "@common/userWorkspaceRoles";

export type AssignableWorkspaceRole =
    | UserWorkspaceRole.ADMIN
    | UserWorkspaceRole.MEMBER
    | UserWorkspaceRole.ACCOUNTANT
    | UserWorkspaceRole.VIEW_ONLY;

export const workspaceLevelRoleDescription: Record<
    AssignableWorkspaceRole,
    string
> = {
    [UserWorkspaceRole.MEMBER]:
        "Assigned entities. Access to reports, transactions, documents, connect bank accounts, and create tasks.",
    [UserWorkspaceRole.ADMIN]:
        "Workspace-wide access. Manage team members, entities, and accounting settings.",
    [UserWorkspaceRole.ACCOUNTANT]:
        "Everything a Member can do plus manage team members, edit chart of accounts, and edit settings.",
    [UserWorkspaceRole.VIEW_ONLY]:
        "Can view assigned entities across the workspace. Cannot make changes in Kick.",
};
